import {request} from '@/axios'

/**
 * @description 查詢用戶信息
 */
export function getUserInfo() {
  return request({
    url: '/user/info',
    method: 'get'
  })
}

/**
 * @description 查詢IM的登陸sign
 */
export function getImSign() {
  return request({
    url: '/im/auth/sign',
    method: 'get'
  })
}

/**
 * @description 發送驗證碼
 * @param {Object} data
 */
export function getSmsCode(data) {
  return request({
    url: '/user/telephone/login/sms/send',
    method: 'post',
    data
  })
}

/**
 * @description 用戶登陸
 * @param {Object} data
 */
export function userLogin(data) {
  return request({
    url: '/user/telephone/login',
    method: 'post',
    data
  })
}

/**
 * @description 查詢帳戶信息
 */
export function getUserAccountDetail() {
  return request({
    url: '/user/account',
    method: 'get'
  })
}

export function getBorderList(params) {
  return request({
    url: 'order/list/master',
    method: 'get',
    params
  })
}

export function getCorderList(params) {
  return request({
    url: 'order/list',
    method: 'get',
    params
  })
}

export function getMasterInfo(params) {
  return request({
    url: 'master/detail',
    method: 'get',
    params,
  })
}



export function getCommentList(params) {
  return request({
    url: 'comment/list',
    method: 'get',
    params,
  })
}
/*
  獲取未讀提示消息
*/
export function getRedCircle() {
  return request({
    url: '/reddot/info',
    method: 'get'
  })
}
/*
  清空未讀提示消息
*/
export function clearRedCircle(data) {
  return request({
    url: '/reddot/clean',
    method: 'post',
    data
  })
}

/*保存最新的优惠策略*/

export function saveNewRules(data) {
  return request({
    url: '/giveaway/batchAdd',
    method: 'post',
    data
  })
}

/*清空技能的优惠策略*/

export function clearSkillRule(data) {
  return request({
    url: '/giveaway/delBySkillId',
    method: 'post',
    data
  })
}

export function getServeList(params) {
  return request({
    url: 'player/skill/certification/skilllist',
    method: 'get',
    params
  })
}
/* 帳戶管理列表 */
export function getAccountList(params) {
  return request({
    url: '/account/statement/list',
    method: 'get',
    params
  })
}

/*登录情况下获取抽成信息*/
export function getUserDeduct() {
  return request({
    url: '/account/stolen/content',
    method: 'get'
  })
}

/*非登录情况下获取抽成信息*/
export function getDefaultDeduct() {
  return request({
    url: '/account/stolen/content/anonymous',
    method: 'get'
  })
}

/* 帐户结算中列表 */
export function getSettlementingList() {
  return request({
    url: '/settlement/list',
    method: 'get'
  })
}

/* 帳戶餘額 */
export function getAccount() {
  return request({
    url: '/user/account',
    method: 'get'
  })
}

/* 用戶優惠券 */
export function getUserCouponInfo(data) {
  return request({
    url: 'coupon/getUserCouponInfo',
    method: 'post',
    data
  })
}

/**
 * @description 申請提現
 * @param {Object} data
 */
export function applyWithdraw(data) {
  return request({
    url: '/account/withdraw/apply',
    method: 'post',
    data
  })
}
/* 提現歷史 */
export function getWithdrawHistory(data) {
  return request({
    url: '/account/withdraw/history',
    method: 'post',
    data
  })
}


/**
 * @description 一鍵遷移接口
 * @param {Object} data
 */
export function migrationTouch(data) {
  return request({
    url: '/miaoyue/move',
    method: 'post',
    data
  })
}

/**
 * @description 獲取邀請紀錄詳情
 */
export function getInvitationInfo() {
  return request({
    url: '/miaoyue/info',
    method: 'get'
  })
}

/**
 * @description 查看b端拉新信息
 */
export function getInvitedList(data) {
  return request({
    url: '/inviterB/list',
    method: 'post',
    data
  })
}

/**
 * @description 查看b端拉新人信息
 */
export function getInvitedDetail(params) {
  return request({
    url: '/inviterB/detail',
    method: 'get',
    params
  })
}

/**
 * @description 设置用户信息
 * @param {Object} data
 */
export function setUserInfo(data) {
  return request({
    url: '/user/save',
    method: 'post',
    data
  })
}

/**
 * @description 查詢用戶相冊
 */
export function getPhotoList() {
  return request({
    url: '/user/photo/list',
    method: 'get'
  })
}

/**
 * @description 上傳相冊照片
 * @param {Object} data
 */
export function uploadPhoto(data) {
  return request({
    url: '/user/photo/create',
    method: 'post',
    data
  })
}

/**
 * @description 相冊照片刪除
 * @param {Object} data
 */
export function deletePhoto(data) {
  return request({
    url: '/user/photo/delete',
    method: 'post',
    data
  })
}

/**
 * @description 相冊照片修改
 * @param {Object} data
 */
export function updatePhoto(data) {
  return request({
    url: '/user/photo/change',
    method: 'post',
    data
  })
}


/**
 * @description 首次联系b端发送短信
 * @param {Object} data
 */
export function shortMessgae(data) {
  return request({
    url: '/im/notify/sms',
    method: 'post',
    data,
  })
} 

/**
 * @description 儲值服務
 * @param {Object} data
 */
export function recharge(data) {
  return request({
    url: '/payment/recharge',
    method: 'post',
    data,
  })
}

/**
 * @description 獲取訪客
 */
export function getVisitors() {
  return request({
    url: '/user/visitor',
    method: 'get'
  })
}

/**
 * @description 大神在線離線
 */
export function setOnlineStatus(data) {
  return request({
    url: '/user/save/onlineStatus',
    method: 'post',
    data
  })
}

/**
 * @description 技能是否存在判断
 */
export function getIsSkill(params) {
  return request({
    url: '/player/skill/detail/info',
    method: 'get',
    params
  })
}

/**
 * @description 获取当前用户被邀请情况
 */
export function getInviterStatus(params) {
  return request({
    url: '/inviterB/find/inviter',
    method: 'get',
    params
  })
}
/**
 * @description 查看b端拉新信息
 */
export function getInviterInfo(params) {
  return request({
    url: '/inviterB/info',
    method: 'get',
    params
  })
}

/**
 * @Unique 查看b端個人頁
 */
export function getMasterInfoUnique(params) {
  return request({
    url: 'inviterB/detail',
    method: 'get',
    params,
  })
}
/**
 * @description 餘額轉收入
 */

export function transferBalance(data) {
  return request({
    url: '/account/inner/transform',
    method: 'post',
    data
  })
}

/**
 * @description 获取白名单用户的权限
 */
export function getWhiteListUserPermissions() {
  return request({
    url: '/gray/scale/config',
    method: 'get'
  })
}

/**
 * 換取LINE的綁定鏈接
 * @param {Object} data 
 */
export function getBindLineNotifyUrl(data) {
  return request({
    url: '/login/notify/authorize',
    method: 'post',
    data
  })
}

/**
 * @description 存儲LINE Notify的token
 * @param {Object} data 
 */
export function saveBindLineToken(data) {
  return request({
    url: '/login/notify/token',
    method: 'post',
    data
  })
}

/**
 * @description 切換LINE通知的接收狀態
 * @param {Object} params
 */
export function switchLineNotifyStatus(params) {
  return request({
    url: '/push/line/switch',
    method: 'get',
    params
  })
}
/**
 * @description social广告分流
 */
export function getSocial() {
  return request({
    url: '/landing/social',
    method: 'get'
  })
}
/**
 * @description gaming广告分流
 */
export function getGaming() {
  return request({
    url: '/landing/game',
    method: 'get'
  })
}
export function showMasterMusk(params) {
  return request({
    url: '/user/chart/guide',
    method: 'get',
    params
  })
}
//email登陆
export function emailLogin(data) {
  return request({
    url: '/login/email/login',
    method: 'post',
    data
  })
}
//email注册
export function emailSignup(data) {
  return request({
    url: '/login/email/register',
    method: 'post',
    data
  })
}
//sendEmailCode登陆
export function sendEmailCode(data) {
  return request({
    url: '/login/email/code',
    method: 'post',
    data
  })
}

//验证邮箱code
export function checkEmailCode(data) {
  return request({
    url: '/login/email/verify/check',
    method: 'post',
    data
  })
}
 
//修改邮箱密码
export function changePassword(data) {
  return request({
    url: '/login/email/password',
    method: 'post',
    data
  })
}

//获取用户登陆相关信息
export function getUserLoginInfo(data) {
  return request({
    url: '/user/login/info',
    method: 'get',
    data
  })
}
//绑定/修改邮箱 
export function changeEmail(data) {
  return request({
    url: '/login/email/change',
    method: 'post',
    data
  })
}

//verfiy认证邮箱
export function verifyEmail(data) {
  return request({
    url: '/login/email/verify',
    method: 'post',
    data
  })
}

//绑定三方账号
export function bindThirdpary(data) {
  return request({
    url: '/login/firebase/add',
    method: 'post',
    data
  })
}

//验证密码是否正确
export function passwordCheckAndChange(data) {
  return request({
    url: '/user/password',
    method: 'post',
    data
  })
}

// 查询全部游戏列表&我感兴趣的游戏列表
export function getGamesList() {
  return request({
    url: 'game/userCustom/get',
    method: 'get'
  })
}

// 獲取配置信息(頭像框信息)
export function getBasicConfig() {
  return request({
    url: '/basic/config',
    method: 'get',
  })
}

// 获取首页轮播
export function getBanner() {
  return request({
    url: '/banner/list',
    method: 'get',
  })
}

// 获取技能推荐
export function getRecommend(data) {
  return request({
    url: '/player/skill/recommend',
    method: 'post',
    data
  })
}

// 获取技能推荐
export function getUserCustom(data) {
  return request({
    url: '/game/userCustom/save',
    method: 'post',
    data
  })
}

/**
 * @description 查詢自己是否拉黑對方
 */
export function blackUser(data) {
  return request({
    url: '/user/black/self/check',
    method: 'post',
    data
  })
}


/**
 * @description 獲取追蹤信息
 * @param {*} params 
 */
export function getFollowInfo(params) {
  return request({
    url: '/user/follow/info',
    method: 'get',
    params,
  })
}
/**
 * @description 拉黑
 */
export function handleBlack(data) {
  return request({
    url: '/user/black/active',
    method: 'post',
    data
  })
}

/**
 * @description 解拉
 */
export function unBlack(data) {
  return request({
    url: '/user/black/inactive',
    method: 'post',
    data
  })
}

export function findc() {
  return request({
    url: '/player/recommend/discoverBoss/list',
    method: 'get',
  })
}

export function chatc(data) {
  return request({
    url: `/player/recommend/discoverBoss/talk`,
    method: 'post',
    data
  })
}
/**
 * @description 獲取充值列表
 */
export function iapRechargeList(params) {
  return request({
    url: '/iap/item/list/recharge',
    method: 'get',
    params,
  })
}

/**
 * @description: 提領帳戶保存
 */
export function withdrawSave(data) {
  return request({
    url: `/withdraw/jp/bank/save`,
    method: 'post',
    data
  })
}

/**
 * @description: 提領帳戶信息
 */
export function withdrawInfo() {
  return request({
    url: `/withdraw/jp/bankInfo`,
    method: 'get'
  })
}

/**
 * @description: 提領申請
 */
export function withdrawApply(data) {
  return request({
    url: `/withdraw/jp/apply`,
    method: 'post',
    data
  })
}

/**
 * @description 查詢用戶信息
 * @param uuid
 */
export function getUserDetail(params) {
  return request({
    url: '/user/detail/info',
    method: 'get',
    params
  })
}

/**
 * @description 去除IM打開對話框的警告提示
 *  
 */
export function clearWarnWindow(params) {
  return request({
    url: '/user/warningWindowClear',
    method: 'get',
    params
  })
}

/**
 * @description: https://api.dev.nicee.app/swagger-ui.html#!/email45login45controller/emailRegOrLoginUsingPOST
 * @param {*} data
 * @return {*}
 */
export function loginWithCode(data) {
  return request({
    url: '/login/email/regOrLogin',
    method: 'post',
    data
  })
}

/**
 * @description 獲取echat初始化數據
 *  
 */
export function getEchatMeta() {
  return request({
    url: '/echat/encrypt',
    method: 'get',
  })
}
/**
 * @description 获取陪陪的最佳排名
 *  
 */
export function getBestRank(params) {
  return request({
    url: '/rank/bestRank',
    method: 'get',
    params
  })
}

/**
 * @description 获取是否关注陪陪
 *  
 */
export function inFollow(params) {
  return request({
    url: 'user/follow/in',
    method: 'get',
    params
  })
}

/**
 * @description 上传活动记录
 *  
 */
export function reportPagelog(data) {
  return request({
    url: `/basic/front/savePageLog`,
    method: 'post',
    data
  })
}

/**
 * @description 解拉
 */
export function report(data) {
  return request({
    url: '/basic/front/error',
    method: 'post',
    data
  })
}
